var alertTriggerControls = {
	limits: "Limits",
	upperLimit: "Superiore",
	upperLimitPlaceholder: "Superiore",
	lowerLimit: "Inferiore",
	lowerLimitPlaceholder: "Inferiore",
	deleteBtn: "Elimina",
	cancelBtn: "Annulla",
	saveBtn: "Salva",
	validationErrors: {
		upperLimit: {
			invalidInput: "Valore non valido. Valore valido: 123.456",
			priceMismatch: "The upper limit must be higher than the current price"
		},
		lowerLimit: {
			invalidInput: "Valore non valido. Valore valido: 123.456",
			priceMismatch: "The lower limit must be lower than the current price"
		}
	}
};
var it = {
	alertTriggerControls: alertTriggerControls
};

export { alertTriggerControls, it as default };
